<template>
<div>
    <ul class="list-group" v-for="information in notifications.data" :key="information.notification_public_id">
  <li class="list-group-item" @click="notification(information.notification_public_id)">
      {{information.message}}
      <i class="ni ni-check-bold text-success lg4"></i>
  </li>
</ul>
</div>


</template>

<script>
    export default {
        name: "Notification",
        data() {
            return {
                
            };
        },
        methods: {
            notification(data){
                console.log(data)
                this.$store.dispatch('updateNotification_function', data);
            }
        }
    }
</script>

<style scoped>

</style>
